<template lang="pug">
BriqPanel
  .panel-header.mb-M
    h2 {{ title }}
    slot(name="heading-action")
  slot(name="body")
</template>

<script>
export default {
  name: 'UpsertBookingPanel',
  props: {
    title: String,
  },
}
</script>

<style scoped lang="stylus">
.panel-header
  display flex
  justify-content space-between
  align-items flex-start
</style>
